import(/* webpackMode: "eager" */ "/app/src/modules/how-it-works/component/views/HowItWorksView.tsx")